import React from "react";
import {thStyles} from "./tableStyles";
import ChangeHistoryRow from "./ChangeHistoryRow";

const ChangeHistory = (props) => (
    <div style={{marginBottom: "0px"}}>
        <h3 style={{color: "#28313E", margin: "20px 20px 0 20px", fontSize: "100%"}}>
            Changes to {props.authorName}'s <span className="x-issuer">{props.issuer}</span> Recommendation
        </h3>
        <div style={{padding: "20px", margin: "0 20px"}}>
            <table style={{width: "100%"}}>
                <thead>
                <tr>
                    <th style={thStyles}>Communication Date</th>
                    <th style={thStyles}></th>
                    <th style={thStyles}>Target Price</th>
                    <th style={thStyles}>Validity Period</th>
                </tr>
                </thead>
                <tbody>
                { props.history.length > 0 ?
                    props.history.map(recommendation =>
                        <ChangeHistoryRow key={recommendation.id}
                            {...recommendation}/>) :
                    undefined }
                </tbody>
            </table>
        </div>
    </div>
);

ChangeHistory.propTypes = {
    history: React.PropTypes.array.isRequired,
    authorName: React.PropTypes.string,
    issuer: React.PropTypes.string
};

export default ChangeHistory;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/components/ChangeHistory.js
 **/